import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.697 12.071l11.313 -7.071l-7.07 11.314l-4.243 -4.243","key":"svg-0"}],["path",{"d":"M8.743 14.475l-2.121 2.121c-1.886 1.886 .943 4.715 2.828 2.829","key":"svg-1"}]]

const IconUmbrellaClosed2 = createReactComponent('outline', 'umbrella-closed-2', 'UmbrellaClosed2', __iconNode);

export default IconUmbrellaClosed2;